<script setup>
import AppPlaceholder from '@/components/UI/AppPlaceholder/AppPlaceholder.vue'
</script>

<template>
  <div class="plan-tasks__skeleton__list">
    <div class="plan-tasks__skeleton__list__item" v-for="item in 10">
      <app-placeholder width="10px" height="10px" border-radius="100%"/>

      <div class="plan-tasks__skeleton__list__item__text">
        <app-placeholder width="30px" height="30px" />
        <app-placeholder width="100px" height="10px" />
      </div>

      <div class="plan-tasks__skeleton__list__item__actions">
        <app-placeholder width="30px" height="30px" />
        <app-placeholder width="30px" height="30px" />
        <app-placeholder width="30px" height="30px" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.plan-tasks__skeleton__list {
  &__item {
    display: flex;
    align-items: center;
    column-gap: 15px;
    margin: 15px 25px 15px 15px;

    &__text {
      display: flex;
      align-items: center;
      column-gap: 5px;
    }

    &__actions {
      display: flex;
      align-items: center;
      column-gap: 10px;
      margin-left: auto;
    }
  }
}
</style>
